import React from 'react';
import { useSelector } from 'react-redux';

import { getApplicationsTabPath } from '../../../../constants/urls';
import { propertyAddressSelector } from '../../../../selectors';
import GenericBackLink from '../../../../components/BackLink';
import useQueryVariables from '../../../../hooks/useQueryVariables';
import { ZTSS_DASHBOARD } from '../../../../constants/paths';

export default function BackLink() {
  const { propertyId } = useQueryVariables();
  const isZtss = useSelector((state) => state.app.isZtss);
  const propertyAddress = useSelector(propertyAddressSelector);
  const to = isZtss ? `${ZTSS_DASHBOARD}?propertyId=${propertyId}` : getApplicationsTabPath(propertyId);
  const displayText = propertyAddress ? `All applications for ${propertyAddress}` : 'All applications';
  return (
    <GenericBackLink to={to} className="zon_applicationSummaryBackLink">
      {displayText}
    </GenericBackLink>
  );
}
